import React from 'react'
import LoginForm from '../components/loginForm'
import { signInWithEmailAndPassword } from '../firebase/login'

const LoginFormContainer = () => <LoginForm signInWithEmailAndPassword={signInWithEmailAndPassword} />


export default LoginFormContainer